import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

import ExamsSetup from '@routes/Home/routes/AdminPortal/routes/ExamGradingSetup/routes/ExamsSetup';
import GradingSetup from './routes/GradingSetup';
import ExamMarksAutomation from './routes/ExamMarksAutomation';
import ExamSetupDetail from '@routes/Home/routes/AdminPortal/routes/ExamGradingSetup/routes/ExamsSetup/routes/ExamSetupDetail';
const ExamSetupLazy = React.lazy(
	() => import(/* webpackChunkName : 'ExamGradingSetup' */ './components')
);

export default (store) => {
	return [
		{
			path: 'examgrading-setup',
			element: (
				<AsyncLoading
					component={<ExamSetupLazy permission="CanViewExamGradingSetup" />}
				/>
			),
			children: [
				ExamsSetup(store),
				GradingSetup(store),
				ExamMarksAutomation(store),
			],
		},
		...ExamSetupDetail(store),
	];
};
